import { faWindowRestore } from "@fortawesome/free-solid-svg-icons";
import React from "react";
import styled, { css } from "styled-components";
import HomeBrand from "./HomeBrand";

const Navbar = () => {
  const [scrolled, setScrolled] = React.useState(false);
  const [scrolled2, setScrolled2] = React.useState(false);
  const [scale, setScale] = React.useState(0.75);
  const [portrait, setPortrait] = React.useState(false);
  const [hamburger, setHamburger] = React.useState(false);
  React.useEffect(() => {
    setInterval(() => {
      console.log(portrait);
      if (window.pageYOffset > 5) {
        setScrolled(true);
        setScrolled2(true);
        if (window.innerWidth <= window.innerHeight) {
          setScale(1.25);
        } else {
          setScale(0.825);
        }
      } else {
        setScrolled(false);
        setScrolled2(false);
        if (window.innerWidth <= window.innerHeight) {
          setScale(1.1);
        } else {
          setScale(0.75);
        }
      }
    }, 250);
  }, []);
  React.useEffect(() => {
    if (window.innerWidth <= window.innerHeight) {
      setPortrait(true);
    } else {
      setPortrait(false);
    }
  });
  return (
    <>
      {portrait === false ? (
        <HomeNavigation scrolled={scrolled}>
          <HomeBrand scale={scale} />
          <NavigationButtons>
            <NavButton
              href="#home"
              other={false}
              scrolled={scrolled}
              bgcolor="transparent"
            >
              Home
            </NavButton>
            <NavButton
              href="#about"
              other={false}
              scrolled={scrolled}
              bgcolor="transparent"
            >
              About
            </NavButton>
            <NavButton
              href="#expertises"
              other={false}
              scrolled={scrolled}
              bgcolor="transparent"
            >
              Portfolio
            </NavButton>
            <NavButton
              href="#testmonials"
              scrolled={scrolled}
              bgcolor="transparent"
            >
              Testmonial
            </NavButton>
            <NavButton
              href="#blog"
              other={false}
              scrolled={scrolled}
              bgcolor="transparent"
            >
              Our Blog
            </NavButton>
            <NavButton
              href="#contact"
              scrolled={scrolled}
              bgcolor="transparent"
            >
              Contact
            </NavButton>
            <NavButton other={true} scrolled2={scrolled2} bgcolor="#f53b4d">
              Components
            </NavButton>
          </NavigationButtons>
        </HomeNavigation>
      ) : (
        <>
          <HomeNavigation scrolled={scrolled}>
            <HomeBrand scale={scale} />
            <HamburgerMenu onClick={() => setHamburger(!hamburger)}>
              <HamburgerDiv change={hamburger} scrolled={scrolled} />
              <HamburgerDiv appear={hamburger} scrolled={scrolled} />
              <HamburgerDiv change1={hamburger} scrolled={scrolled} />
            </HamburgerMenu>
          </HomeNavigation>
          <NavigationButtons scrolled={scrolled} hamburger={hamburger}>
            <NavButton
              href="#home"
              other={false}
              scrolled={scrolled}
              bgcolor="transparent"
            >
              Home
            </NavButton>
            <NavButton
              href="#about"
              other={false}
              scrolled={scrolled}
              bgcolor="transparent"
            >
              About
            </NavButton>
            <NavButton
              href="#expertises"
              scrolled={scrolled}
              bgcolor="transparent"
            >
              Portfolio
            </NavButton>
            <NavButton
              href="#testmonials"
              other={false}
              scrolled={scrolled}
              bgcolor="transparent"
            >
              Testmonial
            </NavButton>
            <NavButton
              other={false}
              href="#blog"
              scrolled={scrolled}
              bgcolor="transparent"
            >
              Our Blog
            </NavButton>
            <NavButton
              href="#contact"
              other={false}
              scrolled={scrolled}
              bgcolor="transparent"
            >
              Contact
            </NavButton>
            <NavButton
              other={true}
              wider
              scrolled2={scrolled2}
              bgcolor="#f53b4d"
            >
              Components
            </NavButton>
          </NavigationButtons>
        </>
      )}
    </>
  );
};

const HamburgerMenu = styled.div`
  width: 8vh;
  height: 8vh;
  margin-left: 30vw;
  cursor: pointer;
  padding-top: 2.5vh;

  display: grid;
  grid-template-columns: repeat(1, 1fr);
  grid-template-rows: repeat(3, 1fr);
  z-index: 1000;
`;

const HamburgerDiv = styled.div`
  width: 8vh;
  height: 1vh;
  background-color: white;

  transition: 150ms;

  ${(props) =>
    props.scrolled &&
    css`
      background-color: black;
    `}

  ${(props) =>
    props.appear &&
    css`
      opacity: 0;
    `}

  ${(props) =>
    props.change &&
    css`
      transform: translateY(270%) rotate(45deg);
    `}
     ${(props) =>
    props.change1 &&
    css`
      transform: translateY(-270%) rotate(-45deg);
    `}
`;

const HomeNavigation = styled.div`
  width: 100vw;
  height: 6vw;
  overflow-x: hidden;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: repeat(1, 1fr);
  position: fixed;
  padding-left: 10vw;

  @media screen and (orientation: portrait) {
    height: 12vh;
    padding-left: 0;
  }

  @media screen and (orientation: landscape) {
    align-items: center;
  }

  z-index: 999;

  transition: 300ms;
  transform-origin: top;
  will-change: background-color;

  ${(props) =>
    props.scrolled &&
    css`
      background-color: white;
      color: black;
      overflow-x: hidden;
      transform: scaleY(0.9);
      box-shadow: rgba(0, 0, 0, 0.1) 0px 20px 25px -5px,
        rgba(0, 0, 0, 0.04) 0px 10px 10px -5px;
    `}
`;

const NavigationButtons = styled.div`
  width: 55vw;
  height: 7vw;
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  grid-template-rows: repeat(1, 1fr);
  justify-items: left;
  align-items: center;
  margin-right: 20vw;

  @media screen and (orientation: portrait) {
    width: 100vw;
    display: grid;
    grid-template-columns: repeat(1, 1fr);
    grid-template-rows: repeat(7, 1fr);
    transform-origin: top;
    transition: 300ms;
    will-change: transform;
    height: 0;
    position: fixed;
    margin-top: 10vh;
    padding-left: 5vw;
    z-index: 998;
    transition: 300ms;
    background-color: rgba(64, 64, 64, 0.3);

    ${(props) =>
      props.scrolled &&
      css`
        background-color: whitesmoke;
      `}

    ${(props) =>
      props.hamburger &&
      css`
        height: 40vh;
      `}
  }
`;

const NavButton = styled.a`
  font: bold Arial;
  width: auto;
  height: auto;
  text-align: center;
  color: white;
  font-size: 0.83vw;
  font-weight: 700;
  cursor: pointer;
  background-color: ${(props) => props.bgcolor};
  border: none;
  transition: 300ms;
  padding: 0.3vw 0.6vw;
  text-decoration: none;

  :hover {
    ${(props) => {
      if (props.other === false) {
        return css`
          color: #f53b4d;
        `;
      }
    }}
  }

  :hover {
    ${(props) =>
      props.other &&
      css`
        color: white;
      `}
  }

  @media screen and (orientation: portrait) {
    width: 14vh;
    height: auto;
    font-size: 2vh;
    z-index: 1000;
    text-align: left;
    padding: 0.5vw 0.8vw;

    ${(props) =>
      props.wider &&
      css`
        width: 90vw;
        text-align: center;
      `}
  }

  transition: 300ms;
  will-change: color;
  will-change: transform;

  ${(props) =>
    props.scrolled &&
    css`
      color: black;
      transform: scaleY(1.1);
    `}

  ${(props) =>
    props.scrolled2 &&
    css`
      transform: scaleY(1.1);
    `}
`;

export default Navbar;
